import React from "react";
import { Box, Typography, Alert, AlertProps } from "@mui/joy";
import ErrorIcon from "@mui/icons-material/Error";

interface ErrorDisplayProps {
  error: string | null;
  onDismiss?: () => void;
  variant?: "solid" | "soft" | "outlined";
  color?: AlertProps["color"];
}

/**
 * Reusable error display component
 * Consistent styling and accessibility across all auth pages
 */
export function ErrorDisplay({ error, onDismiss, variant = "soft", color = "danger" }: ErrorDisplayProps) {
  if (!error) return null;

  return (
    <Alert
      variant={variant}
      color={color}
      startDecorator={<ErrorIcon />}
      endDecorator={
        onDismiss && (
          <button onClick={onDismiss} style={{ background: "none", border: "none", cursor: "pointer" }}>
            ✕
          </button>
        )
      }
      sx={{ mb: 2, display: "flex", alignItems: "center", gap: 1 }}
      role="alert"
      aria-live="polite"
    >
      {error}
    </Alert>
  );
}
